export const useCarousel = () => {
    // * useStates
    const slider = useState<any>("slider", () => null);
    const activeSlideIndex = useState<number>("activeSlideIndex", () => 0);
    const items = useState<any[]>("carousel-items", () => []);
    const sliderIsReady = useState<boolean>("sliderIsReady", () => false);

    // * computed properties
    const showSliderControllers = computed(() => {
        return items.value.length > 1;
    });

    const activeNextSlide = computed(() => {
        if (slider.value) {
            const nextSlide = items.value[activeSlideIndex.value + 1];

            return slider.value.activeIndex == items.value.length - 1 ? "pointer-events-none !opacity-40" : "";
        }
    });

    const activePrevSlide = computed(() => {
        if (slider.value) {
            const prevSlide = items.value[activeSlideIndex.value - 1];

            return slider.value.activeIndex == 0 ? "pointer-events-none !opacity-40" : "";
        }
    });

    // * methods
    const initSwiper = (_items: any[]) => {
        items.value = _items;
    };

    const onSwiper = (swiper: any) => {
        slider.value = swiper;
    };

    const goToSlide = (slideIndex: number) => {
        if (activeSlideIndex.value == slideIndex) return;
        activeSlideIndex.value = slideIndex;
        slider.value.slideTo(slideIndex);
        slider.value.activeIndex = slideIndex;
    };

    const sliderNextHandler = () => {
        activeSlideIndex.value++;
        slider.value.slideNext();
    };

    const sliderPrevHandler = () => {
        activeSlideIndex.value--;
        slider.value.slidePrev();
    };

    return {
        items,
        slider,
        onSwiper,
        goToSlide,
        initSwiper,
        sliderIsReady,
        activeNextSlide,
        activePrevSlide,
        activeSlideIndex,
        sliderNextHandler,
        sliderPrevHandler,
        showSliderControllers,
    };
};
